module.exports = __webpack_public_path__ + "img/bingo_ball-83.acbefa7f.png";